import React, { useState, useEffect } from 'react';
import { Button, Drawer, Form, Input, message } from 'antd';
import './CreditBankDetailsComponent.styles.scss';
// import CurrencyIcon from '../../Common/CurrencyIcon';
import { useGlobalState } from '../../../store/state';
import CreditWithdrawForm from './CreditWithdrawForm';
import UpdateBankDetailsForm from './UpdateBankDetailsForm';
import { ViewBankDetails } from '../../../apis/Influencer/Wallet/ViewBankDetails';
import { SaveBankDetails } from '../../../apis/Influencer/Wallet/SaveBankDetails';
// import { data } from 'browserslist';
import { isMobileOnly } from 'react-device-detect';

// const {Item} = Form;
const CreditBankDetailsComponent = () => {
  // const [bankDetailsForm] = Form.useForm();
  // const [withdrawForm] = Form.useForm();
  const [user] = useGlobalState('user');

  const [bankStats, setBankStats] = useState({
    isPresent: true,
    popUp: false,
    accountType: 'netbanking',
    bankDetails: {
      accountnumber: 0,
      bankname: '',
      branch: '',
      ifsc: '',
      name: '',
      upi: '',
    },
  });

  // @note: common function to fetch bank details
  const getBankDetails =() =>{
    ViewBankDetails(user.accessToken).then(({ response, status })=>{
      if (status === 200) {
        console.log('API: Bank details response ==>', response);
        setBankStats({
          ...bankStats,
          isPresent: response.accountDetails.accountnumber !== 0 ? true:false,
          popUp: false,
          bankDetails: {
            ...response.accountDetails,
          },
        });
        // closeBankDrawer()
      } else {
        message.error('There is some issue with Fetching your bank details');
        // console.log("res fail",response)
      }
    });
  };

  useEffect(() => {
    // @note load bank details for first time
    getBankDetails();
  }, []);
  const showBankDrawer = ()=>{
    setBankStats({
      ...bankStats,
      popUp: true,
    });
  };
  const closeBankDrawer = ()=>{
    setBankStats({
      ...bankStats,
      popUp: false,
    });
  };
  // note: saving bank details
  const updateBankDetails = (_v) =>{
    const _data = {
      accountnumber: _v.accountnumber,
      bankname: _v.bankname,
      branch: _v.branch,
      ifsc: _v.ifsc,
      // name:_v.name,
      upi: _v.upi,
    };

    SaveBankDetails(user.accessToken, {
      ..._data,
      accounttype: bankStats.accountType,
    }).then(({ response, status })=>{
      console.log('Save Bank Details Status', response);
      if (status === 200) {
        getBankDetails();
        message.success('Bank details updated successfully');
      } else {
        message.error('There is some issue with updating bank details');
      }
    });
  };

  return (
    <div className={`common_card p-3 bank_details ${isMobileOnly ? '': 'h-100'}`}>
      {
        bankStats.isPresent?(
        // @note: if bank details present
          <div className="d-flex pb-md-2 bank_details_existing h-100">
            <div className="col-md-12 px-0">
              <div className="d-flex flex-wrap align-items-top h-100">
                <div className={`col-9 px-0 ${isMobileOnly ? '': 'h-100'}`}>
                  <div className="d-flex flex-column justify-content-between h-100">
                    <div className="bank_details_existing_top">
                      <p className="m-0">Account Number</p>
                      <h6 className="m-0">{bankStats.bankDetails.accountnumber || 'N/A'}</h6>
                    </div>
                    <div className="w-100 mt-3 mt-lg-0 d-none d-md-block">
                      <CreditWithdrawForm/>
                    </div>
                  </div>
                </div>
                <div className="col-3 text-right px-0">
                  <Button className="common_button small outlined"
                    onClick={showBankDrawer}>Edit Bank</Button>
                </div>
                {/* mobile only form */}
                <div className="col-12 px-0 pt-4 pb-2 d-block d-md-none ">
                  <CreditWithdrawForm/>
                </div>
              </div>
            </div>
          </div>
        ):
          (
        // @note: if no bank details present
            <div className="d-flex h-100 bank_details_new py-2">
              <div className="col-md-7 px-0">
                <div className="d-flex flex-column justify-content-between h-100">
                  <h4 className="bank_details_new--title">Add Bank Details to <br className="d-none d-md-block"/>withdraw fund</h4>
                  <div>
                    <Button className="common_button outlined mt-4"
                      onClick={showBankDrawer}>Add Bank</Button>
                  </div>
                </div>
              </div>
              <div className="col-md-5 px-0 align-self-center">
                <img src="/images/wallet.svg"
                  className="img-fluid"
                  alt="Wallet Image" />
              </div>
            </div>
          )
      }
      <Drawer
        width={320}
        title={`${bankStats.isPresent ? 'Edit': 'Add'} your bank details`}
        onClose={closeBankDrawer}
        visible={bankStats.popUp}
      >
        <UpdateBankDetailsForm
          bankDetails={bankStats.bankDetails}
          saveBankDetails={updateBankDetails}
        />
      </Drawer>
    </div>
  );
};

export default CreditBankDetailsComponent;
